import { styled } from "styled-components";

export const ValidationErrorDeprecated = styled.p`
  color: var(--toast-notification-crtitcal-or-error, #e43a15);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;
